import { useEffect, useRef } from 'react';
export function useTimeout(callback, delay) {
    const savedCallback = useRef();
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    useEffect(() => {
        function tick() {
            var _a;
            (_a = savedCallback.current) === null || _a === void 0 ? void 0 : _a.call(savedCallback);
        }
        const id = setTimeout(tick, delay);
        return () => clearTimeout(id);
    }, [delay]);
}
